const EXPLICIT_LOGOUT_PENDING_KEY = 'lorath_explicit_logout_pending_v1';

export function markExplicitLogoutPending(): void {
  if (typeof window === 'undefined') return;
  try {
    // Synchron vor dem Logout-Request schreiben: Auch ein sofortiger Reload
    // darf die noch ausstehende lokale Privacy-Bereinigung nicht verlieren.
    window.localStorage.setItem(EXPLICIT_LOGOUT_PENDING_KEY, '1');
  } catch {
    // Der React-State bleibt fuer die laufende Sitzung als Fallback erhalten.
  }
}

export function isExplicitLogoutPending(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(EXPLICIT_LOGOUT_PENDING_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearExplicitLogoutPending(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(EXPLICIT_LOGOUT_PENDING_KEY);
  } catch {
    // Bleibt der Marker erhalten, versucht der naechste Boot den Wipe erneut.
  }
}

